import React from 'react'
import MainSection from '../components/AboutUs/MainSection'
import AboutUs from '../components/AboutUs/AboutUs'
import JobListings from '../components/AboutUs/JobListings'

const AboutUsPage = () => {
  return (
    <>
        <MainSection/>
        <AboutUs/>
        <JobListings/>
    </>
  )
}

export default AboutUsPage